import clsx from "clsx";
import { IButton } from "../Button/Button";
import ButtonGroup from "../ButtonGroup/ButtonGroup";

interface ISectionTitle {
  title: string;
  className?: string;
  buttons?: Array<IButton>;
}

const SectionTitle: React.FC<ISectionTitle> = ({
  title,
  className,
  buttons = [],
}) => {
  return (
    <div
      className={clsx([
        "flex",
        "flex-row",
        "items-center",
        "justify-between",
        "gap-2",
        "w-full",
        "md:text-base",
        "text-sm",
        "uppercase",
        "font-medium",
        "text-gray-500",
        "dark:text-white",
        className,
      ])}
    >
      <h1 className={clsx(["flex", "whitespace-nowrap"])}>{title}</h1>
      {buttons?.length > 0 && (
        <ButtonGroup buttons={buttons} gap={1} align="right" />
      )}
    </div>
  );
};

export default SectionTitle;
